export function checkCommonDomain(email){
  const re = /^(?!.+@(gmail|google|yahoo|outlook|hotmail|msn|aol|icloud|protonmail|mail|yandex|zoho)\..+)(.+@.+\..+)$/
  return !re.test(String(email).toLowerCase())
  //return true if above domains present in the email
}

export function checkValidEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
//returns true if valid

export function checkValidName(name) {
  const invalid = /\b.*[a-zA-Z]+.*\b/
  return invalid.test(String(name))
}
export function checkInvalid(name) {
  const invalid = /[*|\:<>[\]{}`\\();@&$!]/
  return invalid.test(String(name))
}
//returns true if invalid

export function checkInvalidCompany(name) {
  const invalid = /[*|\:<>[\]{}`\\();@$!]/
  return invalid.test(String(name))
}
//returns true if invalid

//Url Validation
export function checkValidUrl(url) {
  const invalid = /(http(s?)):\/\//i
  return !invalid.test(String(url))
}
